(() => {
  if (window.reverieInquiryBasketHeaderReady) return;
  window.reverieInquiryBasketHeaderReady = true;

  const STORAGE_KEY = 'reverie_inquiry_basket_v1';
  const STORAGE_VERSION = 1;

  const readCount = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!stored || stored.version !== STORAGE_VERSION || !Array.isArray(stored.items)) return 0;
      if (Number(stored.expiresAt) <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return 0;
      }
      return stored.items.filter((item) => item && item.productId && item.variantId).length;
    } catch (_error) {
      return 0;
    }
  };

  const updateLinks = (providedCount) => {
    const count = Number.isFinite(Number(providedCount))
      ? Math.max(0, Number(providedCount))
      : readCount();

    document.querySelectorAll('[data-reverie-inquiry-basket-link]').forEach((link) => {
      const countNode = link.querySelector('[data-reverie-inquiry-basket-count]');
      const emptyLabel = link.dataset.emptyLabel || 'Open fabric inquiry basket';
      const countLabel = link.dataset.countLabel || 'Open fabric inquiry basket, [count] fabrics saved';
      if (countNode) countNode.textContent = String(count);
      link.dataset.count = String(count);
      link.setAttribute('aria-label', count > 0 ? countLabel.replace('[count]', String(count)) : emptyLabel);
    });
  };

  window.addEventListener('reverie:inquiry-basket-change', (event) => {
    updateLinks(event.detail?.count);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) updateLinks();
  });
  window.addEventListener('pageshow', () => updateLinks());
  document.addEventListener('shopify:section:load', () => updateLinks());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateLinks(), { once: true });
  } else {
    updateLinks();
  }
})();
